/* eslint-disable @typescript-eslint/no-explicit-any */
export interface ILog {
  [key: string]: any;
  _id?: string;
  timestamp: Date;
  level: string;
  message: string;
  meta: { [key: string]: any };
  companyId: string;
}

export const LogMessageTranslations: { [key: string]: string } = {
  GENERATE_CONTRACT: "Contrato Gerado",
  INSTALLMENT_PAYMENT: "Pagamento de Parcela Realizado",
  "Iniciando auto-renewal process":
    "Iniciando Processo de Renovação Automática",
  LEAD_TO_RENTER: "Lead Convertido em Locatário",
  MOVEMENT_PRODUCT: "Movimentação de Produto",
  NEGOTIATION_REACTIVATION: "Reativação de Negociação",
  PRO_RATA_SUBSCRIPTION: "Assinatura Pro Rata",
  "APPROVED-PURCHASEORDER": "Ordem de Compra Aprovada",
  APROVE_RENTER: "Locatário Aprovado",
  "Approved-PurchaseOrder": "Ordem de Compra Aprovada",
  BLOCK_VEHICLE: "Veículo Bloqueado",
  "CANCEL-PURCHASEORDER": "Ordem de Compra Cancelada",
  CANCEL_RENTER_SUBSCRIPTION: "Assinatura do Locatário Cancelada",
  CONTRACT_FINE: "Multa Contratual Aplicada",
  CONVERT_DEPOSIT: "Depósito Convertido",
  CONVERT_TO_LEAD: "Convertido para Lead",
  "CREATE-EXTERNAL-SERVICE": "Serviço Externo Criado",
  CREATE_AMBASSADOR: "Embaixador Criado",
  CREATE_BILLING_MAINTENANCE: "Cobrança de Manutenção Criada",
  CREATE_BUDGET_MAINTENANCE: "Orçamento de Manutenção Criado",
  CREATE_DEPOSIT: "Depósito Criado",
  CREATE_EMPLOYEE: "Funcionário Criado",
  CREATE_INDICATORS: "Indicadores Criados",
  CREATE_LEAD: "Lead Criado",
  CREATE_LEAD_AMBASSADOR: "Lead de Embaixador Criado",
  CREATE_MAINTENANCE: "Manutenção Criada",
  CREATE_MAINTENANCE_ASAAS: "Cobrança de Manutenção (Asaas) Criada",
  CREATE_MAINTENANCE_PDF: "PDF de Manutenção Gerado",
  CREATE_MAINTENANCE_VISUAL_RECORD: "Registro Visual de Manutenção Criado",
  CREATE_OBSERVATIONS_RENTERS: "Observação de Locatário Adicionada",
  CREATE_OBSERVATIONS_VEHICLES: "Observação de Veículo Adicionada",
  CREATE_PARTNER: "Parceiro Criado",
  CREATE_PIECE: "Peça Criada",
  CREATE_RENTER: "Locatário Criado",
  CREATE_RENTER_STATUS: "Status do Locatário Atualizado",
  CREATE_SUB_PRODUCT: "Subproduto Criado",
  CREATE_SUPPLIERS: "Fornecedor Criado",
  CREATE_TRAFFICFINE: "Multa de Trânsito Criada",
  CREATE_VEHICLE: "Veículo Criado",
  CREATE_VEHICLE_PREPARATION: "Preparação de Veículo Criada",
  CREATE_VEHICLE_VISUAL_RECORDS: "Registro Visual de Veículo Criado",
  "Create Employee": "Funcionário Criado",
  Created: "Registro Criado",
  "DELETE-EXTERNAL-SERVICE": "Serviço Externo Excluído",
  DELETE_PAYMENT: "Pagamento Excluído",
  EDIT_PAYMENT: "Pagamento Editado",
  "Entity change": "Registro Modificado",
  UPDATE_RENTER_STATUS: "Status do Locatário Atualizado",
  UPDATE_RENTER: "Locatário Atualizado",
  CREATE_PAYMENT: "Pagamento Criado",
  DELETE_MAINTENANCE: "Manutenção Excluída",
  DELETE_PARTNER: "Parceiro Excluído",
  DELETE_VEHICLE: "Veículo Excluído",
  FINISH_MAINTENANCE: "Manutenção Finalizada",
  SEND_NOTIFICATION: "Notificação Enviada",
  UNBLOCK_VEHICLE: "Veículo Desbloqueado",
  UPDATE_EMPLOYEE: "Funcionário Atualizado",
  UPDATE_MAINTENANCE: "Manutenção Atualizada",
  UPDATE_PARTNER: "Parceiro Atualizado",
  UPDATE_VEHICLE: "Veículo Atualizado",
  UPLOAD_DOCUMENT: "Upload de Documento Realizado",
  USER_LOGIN: "Login de Usuário",
  USER_LOGOUT: "Logout de Usuário",
};
